import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isAppointment(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.APPOINTMENT && typeof label === 'string' && typeof value === 'string';
}
export function formatAppointment(submission) {
  if (isAppointment(submission) && submission.value) {
    return {
      label: submission.field.view.label,
      value: submission.value
    };
  }
  return undefined;
}
//# sourceMappingURL=appointment-preview.js.map